import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { getIconForFormat } from '@bibliocommons/utils-format';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import SimpleField from '../SimpleField';
import { FORMAT_GROUP_ORDER } from '../../../../constants/FacetConstants';

import './FormatField.scss';

function groupFilters(filters) {
  return Immutable.Map().withMutations(groups =>
    filters.forEach((filter) => {
      filter.get('groupIds').forEach((groupId) => {
        if (groups.has(groupId)) {
          groups.set(groupId, groups.get(groupId).push(filter));
        } else {
          groups.set(groupId, Immutable.List.of(filter));
        }
      });
    })
  )
  .toSeq()
  .filter((value, groupId) => FORMAT_GROUP_ORDER.indexOf(groupId) >= 0)
  .sortBy((value, groupId) => FORMAT_GROUP_ORDER.indexOf(groupId))
  .map((value, group) => (Immutable.Map({ group, filters: value })))
  .toList();
}

class FormatField extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('renderGrouping');
  }

  renderGrouping(grouping) {
    const filters = grouping.get('filters');
    const group = grouping.get('group');

    return (
      <li className={`sub-field ${group}`} key={`SUPERFORMAT.${group.toLowerCase()}`}>
        <SimpleField
          icon={getIconForFormat(group)}
          label={`SUPERFORMAT.${group.toLowerCase()}`}
          group={group}
          fieldId={this.props.fieldId}
          filters={filters}
          activeFilters={this.props.activeFilters}
          initialIsExpanded
          handleToggleFilter={this.props.handleToggleFilter} />
      </li>
    );
  }

  render() {
    const { filters, fieldId } = this.props;
    const groupedFilters = groupFilters(filters);

    return (
      <div className="cp-format-field">
        <h4 className="field-name">
          <FormattedMessage id={`${fieldId}.field`} />
        </h4>
        <ul key={fieldId} className="filter-group">
          {groupedFilters.map(this.renderGrouping)}
        </ul>
      </div>
    );
  }
}

FormatField.propTypes = {
  fieldId: PropTypes.string,
  filters: ImmutablePropTypes.list,
  hasMore: PropTypes.bool,
  activeFilters: ImmutablePropTypes.map,
  handleToggleFilter: React.PropTypes.func
};

export default FormatField;



// WEBPACK FOOTER //
// ./app/components/shared/Facets/FormatField/FormatField.jsx